function useHeaders() {
    const token = sessionStorage.getItem("token");
  
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  
    return headers;
  }
  
  export default useHeaders;
  